import React, { useState, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';
import surveyService from '../services/surveyService';
import toast from 'react-hot-toast';
import ProductSearch from './ProductSearch';
import ConfirmModal from './ConfirmModal';
import {
  Palette,
  DoorOpen,
  Sparkles,
  Lightbulb,
  Box,
  Plus,
  Check,
  Save,
  X,
  Sliders,
  HelpCircle,
  Trash2,
  Search,
  ZoomIn
} from 'lucide-react';

export const DURATEX_PATTERNS = [
  { name: 'Branco TX', linha: 'Padrão Marcenaria', image: null, color: '#FFFFFF' },
  { name: 'Carvalho Brun', linha: 'Thera', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/162thumb_image-theracarvalho-brun1.jpg', color: '#A27F63' },
  { name: 'Timborana Silvestre', linha: 'Thera', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/161thumb_image-theratimborana-silvestre1.jpg', color: '#A88B69' },
  { name: 'Marrom Retrô', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/160thumb_image-essencialmarrom-retro1.jpg', color: '#4F3C34' },
  { name: 'Hibisco', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/159thumb_image-essencialhibisco1.jpg', color: '#8D5858' },
  { name: 'Bege Papiro', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/158thumb_image-essencialbege-papiro1.jpg', color: '#D6C7B2' },
  { name: 'Freijó Imperial', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/148thumb_image-freijimperial.jpg', color: '#AC8454' },
  { name: 'Nogueira Bourbon', linha: 'Design', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/149thumb_image-nogueirabourbon.jpg', color: '#6E5038' },
  { name: 'Moss Absoluto', linha: 'Design', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/150thumb_image-mossabsoluto.jpg', color: '#485248' },
  { name: 'Pérola Absoluto', linha: 'Design', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/151thumb_image-prolaabsoluto.jpg', color: '#E1D9CD' },
  { name: 'Fusion', linha: 'Conceito', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/152thumb_image-fusion.jpg', color: '#827B75' },
  { name: 'Off White', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/139thumb_image-off-white600x600.jpg', color: '#ECE8E1' },
  { name: 'Gianduia Puro', linha: 'Cristallo', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/138thumb_image-gianduiapuro600x600.jpg', color: '#7A7067' },
  { name: 'Linho Belga', linha: 'Trama', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/135thumb_image-linho-belga600x600.jpg', color: '#C9BFB5' },
  { name: 'Downtown', linha: 'Conceito', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/136thumb_image-downtown600x600.jpg', color: '#767472' },
  { name: 'Bétula', linha: 'Essencial Wood', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/131thumb_image-btula600x600.jpg', color: '#DBC8B0' },
  { name: 'Carvalho Malva', linha: 'Design', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/130thumb_image-carvalho-malva600x600.jpg', color: '#BA9C7D' },
  { name: 'Teka Soho', linha: 'Prisma', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/133thumb_image-teka-soho600x600.jpg', color: '#8A7561' },
  { name: 'Nogueira Asti', linha: 'Design', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/132thumb_image-nogueira-asti600x600.jpg', color: '#7A5E47' },
  { name: 'Blush', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/140thumb_image-blush600x600.jpg', color: '#D6A79A' },
  { name: 'Azul Profundo', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/141thumb_image-azulprofundo600x600.jpg', color: '#273D54' },
  { name: 'Carvalho Dian', linha: 'Thera', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/112thumb_image-carvalhodian-600x600.jpg', color: '#B29679' },
  { name: 'Carvalho Lir', linha: 'Thera', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/111thumb_image-carvalholir-600x600.jpg', color: '#CBB296' },
  { name: 'Nazca', linha: 'Conceito', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/108thumb_image-thumnazca.jpg', color: '#8C7D73' },
  { name: 'Oásis', linha: 'Trama', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/90-600x600-oasis.jpg', color: '#D1C0AA' },
  { name: 'Palha', linha: 'Trama', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/92-600x600-palha.jpg', color: '#DFD3BF' },
  { name: 'Branco Diamante Acetinatta', linha: 'Acetinatta', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/101-600x600-_branco-_diamante-_linha-_acetinatta.jpg', color: '#F5F5F5' },
  { name: 'Branco Diamante Essencial', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/99-6-branco_diamante-_essencial.jpg', color: '#F0F0F0' },
  { name: 'Branco Diamante', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/6-branco_diamante-_essencial.jpg', color: '#FFFFFF' },
  { name: 'Branco Diamante HDF', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/98-6-branco_diamante-_essencial.jpg', color: '#FAF8F5' },
  { name: 'Opala Cristallo', linha: 'Cristallo', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/7-opala-_cristallo.jpg', color: '#E5E0D8' },
  { name: 'Thassos', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/12-thassos-_essencial.jpg', color: '#E0DCD7' },
  { name: 'Arenito', linha: 'Conceito', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/4-arenito-_conceito.jpg', color: '#CBBDAF' },
  { name: 'Cristal', linha: 'Original', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/13-cristal-_original.jpg', color: '#ECE8E3' },
  { name: 'Aurora', linha: 'Trama', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/5-aurora-_trama.jpg', color: '#EFE8DD' },
  { name: 'Prata', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/14-prata-_essencial.jpg', color: '#C2C0BD' },
  { name: 'Cinza Fóssil', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/110thumb_image-thumcinzafssil.jpg', color: '#807D7A' },
  { name: 'Quartzo Bienna', linha: 'Prisma', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/106thumb_image-thumquartzobienna.jpg', color: '#9E968E' },
  { name: 'Cinza Sagrado Cristallo', linha: 'Cristallo', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/21-cinza_sagrado-_cristallo.jpg', color: '#969696' },
  { name: 'Cinza Sagrado Essencial', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/20-cinza_sagrado-_essencial.jpg', color: '#909090' },
  { name: 'Portoro', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/79-portoro-_essencial.jpg', color: '#333333' },
  { name: 'Tartufo', linha: 'Acetinatta', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/102-600x600-_tartufo-_linha-_acetinatta.jpg', color: '#544C47' },
  { name: 'Grafite Trama', linha: 'Trama', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/23-grafite-_trama.jpg', color: '#4A4A4A' },
  { name: 'Grafite Acetinatta', linha: 'Acetinatta', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/103-600x600-_grafite-_linha-_acetinatta.jpg', color: '#3D3D3D' },
  { name: 'Preto Acetinatta', linha: 'Acetinatta', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/100-600x600-_preto-_linha-_acetinatta.jpg', color: '#1F1F1F' },
  { name: 'Preto Cristallo Gloss', linha: 'Cristallo', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/96-27-preto-_cristallo.jpg', color: '#141414' },
  { name: 'Preto Cristallo Premium', linha: 'Cristallo', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/97-27-preto-_cristallo.jpg', color: '#181818' },
  { name: 'Preto Cristallo', linha: 'Cristallo', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/27-preto-_cristallo.jpg', color: '#1A1A1A' },
  { name: 'Preto Absoluto', linha: 'Design', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/28-absoluto-_design.jpg', color: '#111111' },
  { name: 'Carvalho Munique', linha: 'Design', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/32-carvalho_munique-_design.jpg', color: '#A48464' },
  { name: 'Nogueira Caiena', linha: 'Design', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/80-nogueira_caiena-_design.jpg', color: '#6B4E38' },
  { name: 'Pau Ferro Natural Essencial', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/36-pau_ferro_natural-_essencial.jpg', color: '#5C3E29' },
  { name: 'Pau Ferro Natural Cristallo', linha: 'Cristallo', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/35-pau_ferro_natural-_cristallo.jpg', color: '#523622' },
  { name: 'Amêndola Rústica', linha: 'Duna', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/3-amendola_rustica-_duna.jpg', color: '#BA9268' },
  { name: 'Certo', linha: 'Essencial Wood', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/105thumb_image-certo.jpg', color: '#BFA17F' },
  { name: 'Jequitibá Rosa', linha: 'Essencial Wood', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/46thumb_image-46-jequitibarosa-essencialwood.jpg', color: '#C49B7A' },
  { name: 'Cumaru Raiz', linha: 'Essencial Wood', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/44-cumaru_raiz-_essencial_wood.jpg', color: '#8A6040' },
  { name: 'Nogueira Cádiz', linha: 'Prisma', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/78-nogueira_cadiz-_prisma.jpg', color: '#7A5B43' },
  { name: 'Larnaca', linha: 'Prisma', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/38-larnaca-_prisma.jpg', color: '#997D66' },
  { name: 'Freijó Puro', linha: 'Essencial Wood', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/47thumb_image-freijopuro600x6001.jpg', color: '#B58E5C' },
  { name: 'Carvalho Hanover', linha: 'Design', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/48-carvalho_hanover-_design.jpg', color: '#A88866' },
  { name: 'Carvalho Avelã', linha: 'Design', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/50thumb_image-50-carvalhoavela-design.jpg', color: '#997858' },
  { name: 'Noce Amêndoa', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/51-noce_amendoa-_essencial.jpg', color: '#A58363' },
  { name: 'Itapuã', linha: 'Essencial Wood', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/52thumb_image-52-itapuaessencialwoodv2.jpg', color: '#C2A078' },
  { name: 'Nogueira Thar', linha: 'Design', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/53-nogueira_thar-_design.jpg', color: '#735640' },
  { name: 'Carvalho Batur', linha: 'Essencial Wood', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/55-carvalho_batur-_essencial_wood.jpg', color: '#8F7358' },
  { name: 'Carvalho Malva (Alt)', linha: 'Design', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/58-carvalho_malva-_design.jpg', color: '#B09274' },
  { name: 'Riviera', linha: 'Cross', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/57-riviera-_cross.jpg', color: '#967C63' },
  { name: 'Carvalho Berlin', linha: 'Design', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/60-carvalho_berlin-_design.jpg', color: '#8A6F56' },
  { name: 'Noce Mare', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/65-noce_mare-_essencial.jpg', color: '#785D48' },
  { name: 'Titânio Trama', linha: 'Trama', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/67-titanio-trama-67.jpg', color: '#787878' },
  { name: 'Titânio Cristallo', linha: 'Cristallo', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/68-titanio-cristallo-thumb-68.jpg', color: '#808080' },
  { name: 'Ovo', linha: 'Original', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/64-ovo-_original.jpg', color: '#E8E2D5' },
  { name: 'Rosa Infinito', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/66-rosa_infinito-_essencial.jpg', color: '#D6A5A3' },
  { name: 'Pinole', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/54-pinole-_essencial.jpg', color: '#A89888' },
  { name: 'Gianduia Natural', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/107thumb_image-thumgianduianatural.jpg', color: '#786C62' },
  { name: 'Gianduia Cristallo', linha: 'Cristallo', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/72-gianduia-_cristallo.jpg', color: '#70655B' },
  { name: 'Gianduia Trama', linha: 'Trama', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/71-gianduia-_trama.jpg', color: '#6E6056' },
  { name: 'Pérola Urbana', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/69thumb_image-69-perolaurbanaessencial.jpg', color: '#A8A098' },
  { name: 'Mint', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/73-mint-_essencial.jpg', color: '#8CA899' },
  { name: 'Verde Floresta', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/87-600x600-verde-floresta.jpg', color: '#2B4736' },
  { name: 'Ocre Solar', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/91-600x600-ocre-solar.jpg', color: '#C98632' },
  { name: 'Azul Astral', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/88-600x600-azul-astral.jpg', color: '#2B4C6F' },
  { name: 'Azul Secreto', linha: 'Essencial', image: 'https://duratex-inspira-prd-images-bucket.s3.amazonaws.com/moodboard-duratex/pattern-thumb/76-azul_secreto-_essencial.jpg', color: '#3B4A5A' }
];

const COLORS_MAP = DURATEX_PATTERNS.reduce((acc, p) => {
  acc[p.name] = p.color;
  return acc;
}, {
  'Branco TX': '#FFFFFF',
  'Off White': '#FAF9F6',
  'Preto': '#1a1a1a',
  'Freijó': '#C4A35A',
  'Carvalho': '#D4A76A'
});

const getPatternObj = (name) => {
  if (!name) return null;
  const normalized = name.trim().toLowerCase();
  return DURATEX_PATTERNS.find(p => p.name.toLowerCase() === normalized) || null;
};

const COLOR_LIST = DURATEX_PATTERNS.map(p => ({
  name: p.name,
  linha: p.linha,
  image: p.image,
  color: p.color,
  border: p.color === '#FFFFFF' || p.color === '#FAF9F6' || p.color === '#F5F5F5' ? '#d1d5db' : p.color
}));

const ACABAMENTO_INFERIOR_OPTIONS = [
  { value: 'Acabamento em pedra', label: 'Acabamento em Pedra', desc: 'Móvel assentado diretamente na base de alvenaria/pedra' },
  { value: 'Pé de Inox', label: 'Pé de Inox', desc: 'Pés metálicos de inox aparentes reguláveis' },
  { value: 'Rodinha', label: 'Rodinha / Rodízio', desc: 'Rodízios para movimentação do móvel' },
  { value: 'Suspenso', label: 'Suspenso / Flutuante', desc: 'Fixado na parede sem contato com o chão' }
];

const CORPO_ARMARIO_OPTIONS = [
  { value: 'Normal', label: 'Normal (15mm/18mm)', desc: 'Estrutura tradicional com fitamento padrão' },
  { value: 'Embutido', label: 'Embutido', desc: 'Portas embutidas alinhadas à caixa do móvel' },
  { value: 'Engrossado', label: 'Engrossado (30mm+)', desc: 'Laterais ou tampos duplos/engrossados de maior espessura' }
];

const SISTEMAS_CORRER_OPTIONS = [
  { value: 'Trilho convencional', label: 'Trilho convencional', desc: 'Sistema apoiado sobre trilhos de alumínio padrão' },
  { value: 'Kit Dominus', label: 'Kit Dominus', desc: 'Sistema suspenso de correr com amortecimento e guias superiores' },
  { value: 'Sistema Coplanar', label: 'Sistema Coplanar', desc: 'Portas em linha no mesmo plano, abrindo em sobreposição suave' }
];

const DOBRADICAS_OPTIONS = [
  'Dobradiça Automática com Amortecedor (Slow)',
  'Dobradiça Sem Amortecedor (Comum)',
  'Dobradiça Click 165° (Abertura Ampla)',
  'Pistão a Gás Basculante (Abertura para cima)',
  'Dobradiça Especial de Canto'
];

const VIDRO_MODELOS = [
  'Espelho normal',
  'Espelho bronze',
  'Espelho fumê',
  'Reflecta bronze',
  'Reflecta prata',
  'Incolor',
  'Canelado'
];

const VIDRO_PERFIL_CORES = ['Preto', 'Bronze', 'Prata', 'Dourado'];

const SERRALHERIA_CORES = ['Preto fosco', 'Dourado', 'Rose', 'Branco'];

const BudgetSheetForm = ({
  surveyId: surveyIdProp,
  environmentId: environmentIdProp,
  environment: environmentProp,
  existingSheet: existingSheetProp,
  onSave,
  onCancel,
  onDelete
}) => {
  const { surveyId: surveyIdParams } = useParams();
  const surveyId = surveyIdProp || surveyIdParams;
  const queryClient = useQueryClient();

  const [newEmbeddedItem, setNewEmbeddedItem] = useState('');
  const [colorSearchInternal, setColorSearchInternal] = useState('');
  const [colorSearchExternal, setColorSearchExternal] = useState('');
  const [existingId, setExistingId] = useState(existingSheetProp?.id || null);
  const [errors, setErrors] = useState({});
  const [confirmState, setConfirmState] = useState({ show: false, onConfirm: null, message: '' });

  // Estados para busca e gestão de múltiplas corrediças e puxadores do estoque
  const [corredicaSearch, setCorredicaSearch] = useState('');
  const [showCorredicaDropdown, setShowCorredicaDropdown] = useState(false);
  const [puxadorSearch, setPuxadorSearch] = useState('');
  const [showPuxadorDropdown, setShowPuxadorDropdown] = useState(false);
  const [selectedZoomImage, setSelectedZoomImage] = useState(null);

  const [formData, setFormData] = useState({
    environment_id: environmentIdProp || existingSheetProp?.environment_id || '',
    model_id: existingSheetProp?.model_id || '',
    ambiente_tipo: existingSheetProp?.ambiente_tipo || '',
    cor_interna: existingSheetProp?.cor_interna || 'Branco TX',
    cor_externa: existingSheetProp?.cor_externa || '',
    cores_externas_adicionais: existingSheetProp?.cores_externas_adicionais || [],
    puxador_tipo: existingSheetProp?.puxador_tipo || 'EXTERNO_CASUAL',
    modelo_puxador: existingSheetProp?.modelo_puxador || '',
    puxador_produto_id: existingSheetProp?.puxador_produto_id || '',
    puxador_cava: existingSheetProp?.puxador_cava || false,
    puxador_fecho_toque: existingSheetProp?.puxador_fecho_toque || false,
    puxadores_selecionados: existingSheetProp?.puxadores_selecionados || [],
    corredicas_selecionadas: existingSheetProp?.corredicas_selecionadas || [],
    modelo_acabamento_portas: existingSheetProp?.modelo_acabamento_portas || '',
    tipo_portas: existingSheetProp?.tipo_portas || 'De abrir',
    tem_porta_abrir: existingSheetProp?.tem_porta_abrir !== undefined ? Boolean(existingSheetProp.tem_porta_abrir) : (existingSheetProp?.tipo_portas === 'De correr' ? false : true),
    dobradica_tipo: existingSheetProp?.dobradica_tipo || 'Dobradiça Automática com Amortecedor (Slow)',
    dobradica_produto_id: existingSheetProp?.dobradica_produto_id || '',
    tem_porta_correr: Boolean(existingSheetProp?.tem_porta_correr || existingSheetProp?.tipo_portas === 'De correr' || existingSheetProp?.tipo_portas === 'De abrir e De correr'),
    sistema_correr_tipo: existingSheetProp?.sistema_correr_tipo || 'Trilho convencional',
    modelo_corpo: existingSheetProp?.modelo_corpo || 'Normal',
    itens_embutidos: existingSheetProp?.itens_embutidos || [],
    itens_embutidos_detalhes: existingSheetProp?.itens_embutidos_detalhes || {},
    modelo_acabamento_inferior: existingSheetProp?.modelo_acabamento_inferior || 'Acabamento em pedra',
    cabide_comum: existingSheetProp?.cabide_comum || false,
    cabide_comum_qtd: existingSheetProp?.cabide_comum_qtd || 0,
    cabide_iluminado: existingSheetProp?.cabide_iluminado || false,
    cabide_iluminado_qtd: existingSheetProp?.cabide_iluminado_qtd || 0,
    cabide_extensivo: existingSheetProp?.cabide_extensivo || false,
    cabide_extensivo_qtd: existingSheetProp?.cabide_extensivo_qtd || 0,
    painel_roda_pe: existingSheetProp?.painel_roda_pe || false,
    painel_suspenso_bigarrilo: existingSheetProp?.painel_suspenso_bigarrilo || false,
    tem_cortineiro: existingSheetProp?.tem_cortineiro === true || existingSheetProp?.tem_cortineiro === 'SIM' ? 'SIM' : 'NAO',
    porta_vidro: existingSheetProp?.porta_vidro === true || existingSheetProp?.porta_vidro === 'SIM' ? 'SIM' : 'NAO',
    porta_vidro_local: existingSheetProp?.porta_vidro_local || '',
    porta_vidro_modelo: existingSheetProp?.porta_vidro_modelo || '',
    porta_vidro_cor_armacao: existingSheetProp?.porta_vidro_cor_armacao || '',
    puxador_vidro_produto_id: existingSheetProp?.puxador_vidro_produto_id || '',
    tem_ferragens_serralheria: existingSheetProp?.tem_ferragens_serralheria === true || existingSheetProp?.tem_ferragens_serralheria === 'SIM' ? 'SIM' : 'NAO',
    ferragens_local: existingSheetProp?.ferragens_local || '',
    ferragens_cor: existingSheetProp?.ferragens_cor || '',
    has_fita_led: existingSheetProp?.has_fita_led === true || existingSheetProp?.tem_fita_led === 'SIM',
    fita_led_local: existingSheetProp?.fita_led_local || '',
    fita_led_cor: existingSheetProp?.fita_led_cor || '',
    observacoes: existingSheetProp?.observacoes || ''
  });

  // Auto-set ambiente_tipo se houver ambiente informado
  useEffect(() => {
    if (environmentProp && !formData.ambiente_tipo) {
      const socialTypes = ['SALA', 'COZINHA', 'AREA_SERVICO', 'VARANDA', 'SALA_JANTAR', 'HALL', 'CORREDOR'];
      const upperType = (environmentProp.environment_type || 'COZINHA').toUpperCase();
      const tipo = socialTypes.includes(upperType) ? 'SOCIAL' : 'SERVICO';
      setFormData(prev => ({ ...prev, ambiente_tipo: tipo }));
    }
  }, [environmentProp, formData.ambiente_tipo]);

  // Se existingSheetProp mudar, carregar dados
  useEffect(() => {
    if (existingSheetProp) {
      setExistingId(existingSheetProp.id);

      // Se tiver puxador_produto_id ou puxador_produto_nome prévio, inicializar puxadores_selecionados
      let initialPuxadores = existingSheetProp.puxadores_selecionados || [];
      if (initialPuxadores.length === 0 && (existingSheetProp.puxador_produto_id || existingSheetProp.puxador_produto_nome)) {
        initialPuxadores = [{
          id: 'initial_puxador',
          variante_id: existingSheetProp.puxador_produto_id,
          produto_nome: existingSheetProp.puxador_produto_nome || existingSheetProp.modelo_puxador || 'Puxador',
          sku_variacao: existingSheetProp.puxador_sku || '',
          imagem_url: existingSheetProp.puxador_imagem_url || null,
          quantidade: 1,
          aplicacao: ''
        }];
      }

      setFormData(prev => ({
        ...prev,
        ...existingSheetProp,
        cor_interna: existingSheetProp.cor_interna || 'Branco TX',
        cores_externas_adicionais: existingSheetProp.cores_externas_adicionais || [],
        corredicas_selecionadas: existingSheetProp.corredicas_selecionadas || [],
        puxadores_selecionados: initialPuxadores,
        puxador_fecho_toque: Boolean(existingSheetProp.puxador_fecho_toque),
        tem_porta_abrir: existingSheetProp.tem_porta_abrir !== undefined ? Boolean(existingSheetProp.tem_porta_abrir) : (existingSheetProp.tipo_portas === 'De correr' ? false : true),
        dobradica_tipo: existingSheetProp.dobradica_tipo || 'Dobradiça Automática com Amortecedor (Slow)',
        dobradica_produto_id: existingSheetProp.dobradica_produto_id || '',
        tem_porta_correr: Boolean(existingSheetProp.tem_porta_correr || existingSheetProp.tipo_portas === 'De correr' || existingSheetProp.tipo_portas === 'De abrir e De correr'),
        sistema_correr_tipo: existingSheetProp.sistema_correr_tipo || 'Trilho convencional',
        itens_embutidos_detalhes: existingSheetProp.itens_embutidos_detalhes || {},
        tem_cortineiro: existingSheetProp.tem_cortineiro === true || existingSheetProp.tem_cortineiro === 'SIM' ? 'SIM' : 'NAO',
        porta_vidro: existingSheetProp.porta_vidro === true || existingSheetProp.porta_vidro === 'SIM' ? 'SIM' : 'NAO',
        tem_ferragens_serralheria: existingSheetProp.tem_ferragens_serralheria === true || existingSheetProp.tem_ferragens_serralheria === 'SIM' ? 'SIM' : 'NAO',
        has_fita_led: existingSheetProp.has_fita_led === true || existingSheetProp.tem_fita_led === 'SIM',
      }));
    }
  }, [existingSheetProp]);

  // Buscar modelos e opções
  const { data: optionsData } = useQuery({
    queryKey: ['budget-sheet-options'],
    queryFn: () => api.get('/surveys/budget-sheets/options').then(res => res.data),
    staleTime: 5 * 60 * 1000
  });

  // Buscar itens embutidos
  const { data: embeddedItems } = useQuery({
    queryKey: ['embedded-items'],
    queryFn: () => api.get('/embedded-items').then(res => res.data.data),
    staleTime: 60 * 1000
  });

  // Buscar corrediças disponíveis no estoque
  const { data: corredicasProductsData, isLoading: isLoadingCorredicas } = useQuery({
    queryKey: ['corredicas-products', corredicaSearch],
    queryFn: () => surveyService.getAvailableProducts({
      categoria: 'corredi',
      search: corredicaSearch || undefined,
      limit: 30
    }),
    enabled: showCorredicaDropdown || corredicaSearch.length >= 2
  });
  const availableCorredicas = corredicasProductsData?.data || [];

  // Buscar puxadores disponíveis no estoque
  const { data: puxadoresProductsData, isLoading: isLoadingPuxadores } = useQuery({
    queryKey: ['puxadores-products', puxadorSearch],
    queryFn: () => surveyService.getAvailableProducts({
      categoria: 'puxad',
      search: puxadorSearch || undefined,
      limit: 30
    }),
    enabled: showPuxadorDropdown || puxadorSearch.length >= 2
  });
  const availablePuxadores = puxadoresProductsData?.data || [];

  const handleAddPuxador = (variante) => {
    const newPuxador = {
      id: Date.now().toString(),
      variante_id: variante.id,
      produto_id: variante.produto_id,
      produto_nome: variante.produto_nome || variante.nome || 'Puxador',
      sku_variacao: variante.sku_variacao || '',
      cor: variante.cor || '',
      medida_text: variante.medida_text || variante.tamanho_label || '',
      tamanho_label: variante.tamanho_label || '',
      espessura_mm: variante.espessura_mm || null,
      marca_nome: variante.marca_nome || '',
      categoria_nome: variante.categoria_nome || 'Puxadores',
      imagem_url: variante.imagem_url || null,
      preco_custo: variante.preco_custo || 0,
      preco_venda: variante.preco_venda || 0,
      quantidade: 1,
      aplicacao: '',
      fornecedor_nome: (variante.fornecedores_precos && variante.fornecedores_precos[0]?.fornecedor_nome) || null
    };

    setFormData(prev => {
      const list = [...(prev.puxadores_selecionados || []), newPuxador];
      return {
        ...prev,
        puxadores_selecionados: list,
        puxador_produto_id: list[0]?.variante_id || list[0]?.id || prev.puxador_produto_id,
        modelo_puxador: list[0]?.produto_nome || prev.modelo_puxador
      };
    });

    setPuxadorSearch('');
    setShowPuxadorDropdown(false);
    toast.success(`Puxador "${newPuxador.produto_nome}" selecionado!`);
  };

  const handleUpdatePuxador = (index, field, value) => {
    setFormData(prev => {
      const list = [...(prev.puxadores_selecionados || [])];
      list[index] = { ...list[index], [field]: value };
      return {
        ...prev,
        puxadores_selecionados: list,
        puxador_produto_id: list[0]?.variante_id || list[0]?.id || prev.puxador_produto_id,
        modelo_puxador: list[0]?.produto_nome || prev.modelo_puxador
      };
    });
  };

  const handleRemovePuxador = (index) => {
    setFormData(prev => {
      const list = (prev.puxadores_selecionados || []).filter((_, i) => i !== index);
      return {
        ...prev,
        puxadores_selecionados: list,
        puxador_produto_id: list.length > 0 ? (list[0].variante_id || list[0].id) : '',
        modelo_puxador: list.length > 0 ? list[0].produto_nome : ''
      };
    });
  };

  const handleAddCorredica = (variante) => {
    const newCorredica = {
      id: Date.now().toString(),
      variante_id: variante.id,
      produto_id: variante.produto_id,
      produto_nome: variante.produto_nome || variante.nome || 'Corrediça',
      sku_variacao: variante.sku_variacao || '',
      cor: variante.cor || '',
      medida_text: variante.medida_text || variante.tamanho_label || '',
      tamanho_label: variante.tamanho_label || '',
      espessura_mm: variante.espessura_mm || null,
      marca_nome: variante.marca_nome || '',
      categoria_nome: variante.categoria_nome || 'Corrediças',
      imagem_url: variante.imagem_url || null,
      preco_custo: variante.preco_custo || 0,
      preco_venda: variante.preco_venda || 0,
      pares_qtd: 1,
      aplicacao: '',
      fornecedor_nome: (variante.fornecedores_precos && variante.fornecedores_precos[0]?.fornecedor_nome) || null
    };

    setFormData(prev => ({
      ...prev,
      corredicas_selecionadas: [
        ...(prev.corredicas_selecionadas || []),
        newCorredica
      ]
    }));

    setCorredicaSearch('');
    setShowCorredicaDropdown(false);
    toast.success(`Corrediça "${newCorredica.produto_nome}" adicionada!`);
  };

  const handleUpdateCorredica = (index, field, value) => {
    setFormData(prev => {
      const list = [...(prev.corredicas_selecionadas || [])];
      list[index] = { ...list[index], [field]: value };
      return { ...prev, corredicas_selecionadas: list };
    });
  };

  const handleRemoveCorredica = (index) => {
    setFormData(prev => ({
      ...prev,
      corredicas_selecionadas: (prev.corredicas_selecionadas || []).filter((_, i) => i !== index)
    }));
  };

  // Mutation para criar item embutido
  const createEmbeddedMutation = useMutation({
    mutationFn: (name) => api.post('/embedded-items', { name }),
    onSuccess: () => {
      queryClient.invalidateQueries(['embedded-items']);
      setNewEmbeddedItem('');
      toast.success('Item adicionado com sucesso!');
    },
    onError: () => toast.error('Erro ao adicionar item')
  });

  // Mutation para deletar item embutido
  const deleteEmbeddedMutation = useMutation({
    mutationFn: (id) => api.delete(`/embedded-items/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries(['embedded-items']);
      toast.success('Item removido com sucesso!');
    },
    onError: () => toast.error('Erro ao remover item')
  });

  const handleAddEmbeddedItem = () => {
    if (newEmbeddedItem.trim()) {
      createEmbeddedMutation.mutate(newEmbeddedItem.trim());
    }
  };

  const handleDeleteEmbeddedItem = (id) => {
    setConfirmState({
      show: true,
      message: 'Deseja remover este item da lista global de itens embutidos?',
      onConfirm: () => {
        deleteEmbeddedMutation.mutate(id);
        setConfirmState({ show: false, onConfirm: null, message: '' });
      }
    });
  };

  // Handlers para Cores Externas Adicionais
  const handleAddCorExterna = () => {
    setFormData(prev => ({
      ...prev,
      cores_externas_adicionais: [
        ...(prev.cores_externas_adicionais || []),
        { id: Date.now().toString(), cor: '', local: '' }
      ]
    }));
  };

  const handleRemoveCorExterna = (index) => {
    setFormData(prev => ({
      ...prev,
      cores_externas_adicionais: (prev.cores_externas_adicionais || []).filter((_, i) => i !== index)
    }));
  };

  const handleUpdateCorExterna = (index, field, value) => {
    setFormData(prev => {
      const list = [...(prev.cores_externas_adicionais || [])];
      list[index] = { ...list[index], [field]: value };
      return { ...prev, cores_externas_adicionais: list };
    });
  };

  // Handler para dimensões e modelo de eletros embutidos
  const handleUpdateEmbeddedItemDetail = (itemId, field, value) => {
    setFormData(prev => ({
      ...prev,
      itens_embutidos_detalhes: {
        ...(prev.itens_embutidos_detalhes || {}),
        [itemId]: {
          ...((prev.itens_embutidos_detalhes || {})[itemId] || {}),
          [field]: value
        }
      }
    }));
  };

  // Mutation para salvar ficha
  const saveMutation = useMutation({
    mutationFn: (data) => surveyService.createOrUpdateBudgetSheet(surveyId, { ...data, id: existingId }),
    onSuccess: (response) => {
      toast.success(existingId ? 'Ficha de orçamento atualizada!' : 'Ficha de orçamento criada com sucesso!');
      if (response.data?.id) {
        setExistingId(response.data.id);
      }
      queryClient.invalidateQueries(['budget-sheets', surveyId]);
      if (onSave) {
        onSave(response.data || response);
      }
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Erro ao salvar ficha');
    }
  });

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: null }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.cor_interna?.trim()) {
      newErrors.cor_interna = 'Cor interna é obrigatória';
    }
    if (!formData.cor_externa?.trim()) {
      newErrors.cor_externa = 'Cor externa é obrigatória';
    }
    if (!formData.modelo_corpo) {
      newErrors.modelo_corpo = 'Selecione o modelo do corpo';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      let tipoPortasFinal = 'De abrir';
      if (formData.tem_porta_abrir && formData.tem_porta_correr) {
        tipoPortasFinal = 'De abrir e De correr';
      } else if (formData.tem_porta_correr) {
        tipoPortasFinal = 'De correr';
      } else if (formData.tem_porta_abrir) {
        tipoPortasFinal = 'De abrir';
      }

      // Normalizar campos para envio
      const payload = {
        ...formData,
        tipo_portas: tipoPortasFinal,
        tem_porta_abrir: Boolean(formData.tem_porta_abrir),
        tem_porta_correr: Boolean(formData.tem_porta_correr),
        dobradica_tipo: formData.dobradica_tipo || null,
        dobradica_produto_id: formData.dobradica_produto_id || null,
        sistema_correr_tipo: formData.sistema_correr_tipo || null,
        environment_id: formData.environment_id || environmentIdProp || null,
        porta_vidro: formData.porta_vidro === 'SIM',
        tem_cortineiro: formData.tem_cortineiro === 'SIM',
        tem_ferragens_serralheria: formData.tem_ferragens_serralheria === 'SIM',
        has_fita_led: Boolean(formData.has_fita_led),
        tem_fita_led: formData.has_fita_led ? 'SIM' : 'NAO'
      };
      saveMutation.mutate(payload);
    } else {
      toast.error('Preencha os campos obrigatórios em destaque');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const options = optionsData?.data || {};

  // Cores filtradas para seleção rápida
  const filteredInternalColors = useMemo(() => {
    if (!colorSearchInternal.trim()) return COLOR_LIST.slice(0, 24);
    const search = colorSearchInternal.toLowerCase();
    return COLOR_LIST.filter(c => c.name.toLowerCase().includes(search) || (c.linha && c.linha.toLowerCase().includes(search)));
  }, [colorSearchInternal]);

  const filteredExternalColors = useMemo(() => {
    if (!colorSearchExternal.trim()) return COLOR_LIST.slice(0, 24);
    const search = colorSearchExternal.toLowerCase();
    return COLOR_LIST.filter(c => c.name.toLowerCase().includes(search) || (c.linha && c.linha.toLowerCase().includes(search)));
  }, [colorSearchExternal]);

  return (
    <div className="max-w-6xl mx-auto space-y-6">
      {/* Sub-Header Contextual */}
      <div className="bg-gradient-to-r from-green-50/70 to-white p-4 rounded-xl border border-green-200/80 flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-[#49943d] text-white flex items-center justify-center shadow-sm">
            <Palette className="w-5 h-5" />
          </div>
          <div>
            <h2 className="text-base sm:text-lg font-bold text-gray-900">
              Especificações Técnicas de Orçamento
            </h2>
            <p className="text-xs text-gray-500">
              Ambiente vinculado:{' '}
              <strong className="text-gray-800">
                {environmentProp?.environment_name || 'Geral / Sem ambiente definido'}
              </strong>
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          {onCancel && (
            <button
              type="button"
              onClick={onCancel}
              className="px-3.5 py-1.5 text-xs text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 font-medium transition-colors"
            >
              Cancelar
            </button>
          )}
          <button
            type="button"
            onClick={handleSubmit}
            disabled={saveMutation.isPending}
            className="px-4 py-1.5 text-xs text-white bg-[#49943d] hover:bg-[#3a7630] rounded-lg font-bold shadow-sm transition-all flex items-center gap-1.5 disabled:opacity-50"
          >
            <Save className="w-3.5 h-3.5" />
            <span>{saveMutation.isPending ? 'Salvando...' : 'Salvar Ficha'}</span>
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">

        {/* CARD 1: Cores do MDF e Simulador Visual da Porta */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 sm:p-6 space-y-6">
          <div className="flex items-center justify-between pb-3 border-b border-gray-100">
            <div className="flex items-center gap-2">
              <Palette className="w-5 h-5 text-[#49943d]" />
              <h3 className="text-base font-bold text-gray-900">1. Cores e Padrões de MDF</h3>
            </div>
            <span className="text-xs font-semibold text-gray-500">Obrigatório</span>
          </div>

          {/* Simulador / Preview Visual Realista */}
          <div className="p-4 bg-gray-50 rounded-xl border border-gray-200">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-4 text-center">
              Simulador Visual da Frente do Armário
            </p>
            <div className="flex justify-center items-center gap-6 sm:gap-10 flex-wrap">
              {/* Face Externa Principal */}
              <div className="flex flex-col items-center">
                <span className="text-xs font-semibold text-gray-700 mb-2">Parte Externa (Principal)</span>
                {(() => {
                  const patternExterna = getPatternObj(formData.cor_externa);
                  return (
                    <div
                      className="relative w-32 h-44 rounded-lg shadow-md overflow-hidden transition-all duration-300 border-4 border-gray-300 flex items-center justify-end pr-2 bg-cover bg-center"
                      style={{
                        backgroundColor: patternExterna?.color || COLORS_MAP[formData.cor_externa] || '#d1d5db',
                        backgroundImage: patternExterna?.image ? `url(${patternExterna.image})` : 'none',
                        borderColor: patternExterna?.color || COLORS_MAP[formData.cor_externa] || '#9ca3af'
                      }}
                    >
                      {/* Puxador virtual */}
                      <div className="w-1.5 h-10 rounded-full bg-neutral-800 shadow-md opacity-90 border border-neutral-600" />
                    </div>
                  );
                })()}
                <span className="mt-2 text-xs font-bold text-gray-800 text-center flex items-center gap-1">
                  {formData.cor_externa || 'Não selecionada'}
                  {getPatternObj(formData.cor_externa)?.linha && (
                    <span className="px-1.5 py-0.2 bg-purple-100 text-purple-700 rounded text-[10px] font-normal">
                      {getPatternObj(formData.cor_externa).linha}
                    </span>
                  )}
                </span>
              </div>

              {/* Faces Externas Adicionais no Simulador */}
              {(formData.cores_externas_adicionais || []).map((corExtra, idx) => {
                const patternExtra = getPatternObj(corExtra.cor);
                return (
                  <div key={corExtra.id || idx} className="flex flex-col items-center animate-fadeIn">
                    <span className="text-xs font-medium text-purple-800 mb-2 truncate max-w-[130px]">
                      {corExtra.local || `Cor Externa ${idx + 2}`}
                    </span>
                    <div
                      className="relative w-32 h-44 rounded-lg shadow-md overflow-hidden transition-all duration-300 border-4 border-purple-300 flex items-center justify-end pr-2 bg-cover bg-center"
                      style={{
                        backgroundColor: patternExtra?.color || COLORS_MAP[corExtra.cor] || '#d1d5db',
                        backgroundImage: patternExtra?.image ? `url(${patternExtra.image})` : 'none',
                        borderColor: patternExtra?.color || COLORS_MAP[corExtra.cor] || '#a855f7'
                      }}
                    >
                      <div className="w-1.5 h-10 rounded-full bg-neutral-800 shadow-md opacity-90 border border-neutral-600" />
                    </div>
                    <span className="mt-2 text-xs font-bold text-gray-800 text-center flex items-center gap-1 truncate max-w-[130px]">
                      {corExtra.cor || 'Não definida'}
                    </span>
                  </div>
                );
              })}

              {/* Face Interna */}
              <div className="flex flex-col items-center">
                <span className="text-xs font-semibold text-gray-700 mb-2">Parte Interna (Caixaria)</span>
                {(() => {
                  const patternInterna = getPatternObj(formData.cor_interna);
                  return (
                    <div
                      className="relative w-32 h-44 rounded-lg shadow-md overflow-hidden transition-all duration-300 border-4 border-gray-300 flex flex-col justify-between p-2 bg-cover bg-center"
                      style={{
                        backgroundColor: patternInterna?.color || COLORS_MAP[formData.cor_interna] || '#ffffff',
                        backgroundImage: patternInterna?.image ? `url(${patternInterna.image})` : 'none',
                        borderColor: patternInterna?.color || COLORS_MAP[formData.cor_interna] || '#e5e7eb'
                      }}
                    >
                      {/* Prateleiras virtuais */}
                      <div className="w-full h-1.5 bg-neutral-800/20 backdrop-blur-xs rounded shadow-2xs" />
                      <div className="w-full h-1.5 bg-neutral-800/20 backdrop-blur-xs rounded shadow-2xs" />
                    </div>
                  );
                })()}
                <span className="mt-2 text-xs font-bold text-gray-800 text-center flex items-center gap-1">
                  {formData.cor_interna || 'Não selecionada'}
                  {getPatternObj(formData.cor_interna)?.linha && (
                    <span className="px-1.5 py-0.2 bg-blue-100 text-blue-700 rounded text-[10px] font-normal">
                      {getPatternObj(formData.cor_interna).linha}
                    </span>
                  )}
                </span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-2">
            {/* Seletor Parte Interna */}
            <div className="space-y-3">
              <div>
                <div className="flex items-center justify-between mb-1.5">
                  <label className="block text-xs font-bold text-gray-700 uppercase tracking-wider">
                    Cor Parte Interna *
                  </label>
                  <button
                    type="button"
                    onClick={() => handleChange('cor_interna', 'Branco TX')}
                    className="text-[11px] font-semibold text-[#2f6626] bg-green-50 hover:bg-green-100 border border-green-200 px-2 py-0.5 rounded-md flex items-center gap-1 transition-colors shadow-2xs"
                    title="Preencher com Branco TX (padrão caixaria interna)"
                  >
                    <span>⚡ Branco TX (Padrão Caixaria)</span>
                  </button>
                </div>
                <div className="relative">
                  <input
                    type="text"
                    value={formData.cor_interna}
                    onChange={(e) => handleChange('cor_interna', e.target.value)}
                    placeholder="Ex: Branco TX, Carvalho Brun..."
                    className={`w-full px-3.5 py-2.5 bg-white border rounded-xl text-sm focus:ring-2 focus:ring-[#49943d] ${
                      errors.cor_interna ? 'border-red-400 bg-red-50/30' : 'border-gray-300'
                    }`}
                  />
                </div>
                {errors.cor_interna && (
                  <p className="text-xs text-red-600 mt-1 font-medium">{errors.cor_interna}</p>
                )}
              </div>

              <div>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-[11px] font-medium text-gray-500">Padrões Duratex / MDF:</span>
                  <input
                    type="text"
                    placeholder="Filtrar padrão ou linha..."
                    value={colorSearchInternal}
                    onChange={(e) => setColorSearchInternal(e.target.value)}
                    className="text-xs px-2 py-1 border border-gray-200 rounded-lg w-36 focus:ring-1 focus:ring-[#49943d]"
                  />
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-1.5 max-h-48 overflow-y-auto p-1.5 border border-gray-100 rounded-xl bg-gray-50/50">
                  {filteredInternalColors.map((cor) => {
                    const isSelected = formData.cor_interna === cor.name;
                    return (
                      <button
                        key={cor.name}
                        type="button"
                        onClick={() => handleChange('cor_interna', cor.name)}
                        className={`flex items-center gap-2 p-1.5 rounded-lg text-xs font-medium border text-left transition-all ${
                          isSelected
                            ? 'border-[#49943d] bg-green-50 text-[#2f6626] ring-1 ring-[#49943d] shadow-xs'
                            : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-100 hover:border-gray-300'
                        }`}
                      >
                        {cor.image ? (
                          <img
                            src={cor.image}
                            alt={cor.name}
                            className="w-6 h-6 rounded-md object-cover border border-gray-300 flex-shrink-0 shadow-2xs"
                          />
                        ) : (
                          <span
                            className="w-6 h-6 rounded-md border flex-shrink-0 shadow-2xs"
                            style={{ backgroundColor: cor.color, borderColor: cor.border }}
                          />
                        )}
                        <div className="min-w-0 flex-1">
                          <p className="truncate text-[11px] font-semibold leading-tight">{cor.name}</p>
                          {cor.linha && (
                            <p className="text-[9px] text-gray-400 truncate">{cor.linha}</p>
                          )}
                        </div>
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Seletor Parte Externa Principal */}
            <div className="space-y-3">
              <div>
                <label className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">
                  Cor Externa Principal (Inferiores / Frentes) *
                </label>
                <div className="relative">
                  <input
                    type="text"
                    value={formData.cor_externa}
                    onChange={(e) => handleChange('cor_externa', e.target.value)}
                    placeholder="Ex: Freijó Imperial, Gianduia..."
                    className={`w-full px-3.5 py-2.5 bg-white border rounded-xl text-sm focus:ring-2 focus:ring-[#49943d] ${
                      errors.cor_externa ? 'border-red-400 bg-red-50/30' : 'border-gray-300'
                    }`}
                  />
                </div>
                {errors.cor_externa && (
                  <p className="text-xs text-red-600 mt-1 font-medium">{errors.cor_externa}</p>
                )}
              </div>

              <div>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-[11px] font-medium text-gray-500">Padrões Duratex / MDF:</span>
                  <input
                    type="text"
                    placeholder="Filtrar padrão ou linha..."
                    value={colorSearchExternal}
                    onChange={(e) => setColorSearchExternal(e.target.value)}
                    className="text-xs px-2 py-1 border border-gray-200 rounded-lg w-36 focus:ring-1 focus:ring-[#49943d]"
                  />
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-1.5 max-h-48 overflow-y-auto p-1.5 border border-gray-100 rounded-lg bg-gray-50/50">
                  {filteredExternalColors.map((cor) => {
                    const isSelected = formData.cor_externa === cor.name;
                    return (
                      <button
                        key={cor.name}
                        type="button"
                        onClick={() => handleChange('cor_externa', cor.name)}
                        className={`flex items-center gap-2 p-1.5 rounded-lg text-xs font-medium border text-left transition-all ${
                          isSelected
                            ? 'border-[#49943d] bg-green-50 text-[#2f6626] ring-1 ring-[#49943d] shadow-xs'
                            : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-100 hover:border-gray-300'
                        }`}
                      >
                        {cor.image ? (
                          <img
                            src={cor.image}
                            alt={cor.name}
                            className="w-6 h-6 rounded-md object-cover border border-gray-300 flex-shrink-0 shadow-2xs"
                          />
                        ) : (
                          <span
                            className="w-6 h-6 rounded-md border flex-shrink-0 shadow-2xs"
                            style={{ backgroundColor: cor.color, borderColor: cor.border }}
                          />
                        )}
                        <div className="min-w-0 flex-1">
                          <p className="truncate text-[11px] font-semibold leading-tight">{cor.name}</p>
                          {cor.linha && (
                            <p className="text-[9px] text-gray-400 truncate">{cor.linha}</p>
                          )}
                        </div>
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          {/* Seção de Cores Externas Adicionais */}
          <div className="pt-4 border-t border-gray-200">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-3">
              <div>
                <h4 className="text-xs font-bold text-gray-800 uppercase tracking-wider">
                  Cores Externas Adicionais (Para projetos com mais de duas cores)
                </h4>
                <p className="text-[11px] text-gray-500">
                  Defina cores extras para aéreos, nichos, torre quente ou detalhes do ambiente.
                </p>
              </div>
              <button
                type="button"
                onClick={handleAddCorExterna}
                className="text-xs font-semibold px-3 py-1.5 bg-purple-50 text-purple-700 hover:bg-purple-100 border border-purple-200 rounded-lg flex items-center gap-1.5 transition-colors shadow-2xs self-start sm:self-auto"
              >
                <Plus className="w-3.5 h-3.5" />
                <span>Adicionar Outra Cor Externa</span>
              </button>
            </div>

            {(formData.cores_externas_adicionais || []).length > 0 ? (
              <div className="space-y-3">
                {formData.cores_externas_adicionais.map((extraColor, idx) => (
                  <div
                    key={extraColor.id || idx}
                    className="p-3.5 bg-purple-50/40 border border-purple-200 rounded-xl flex flex-col md:flex-row items-stretch md:items-center gap-3 animate-fadeIn"
                  >
                    <div className="w-full md:w-1/3">
                      <label className="block text-[11px] font-bold text-purple-900 mb-1">
                        Local da Aplicação (Onde será usada?)
                      </label>
                      <input
                        type="text"
                        value={extraColor.local}
                        onChange={(e) => handleUpdateCorExterna(idx, 'local', e.target.value)}
                        placeholder="Ex: Armários Aéreos, Nicho Decorativo, Torre..."
                        className="w-full px-3 py-1.5 bg-white border border-purple-300 rounded-lg text-xs font-medium text-gray-900 focus:ring-2 focus:ring-purple-500"
                      />
                    </div>

                    <div className="flex-1">
                      <label className="block text-[11px] font-bold text-purple-900 mb-1">
                        Padrão / Cor do MDF
                      </label>
                      <input
                        type="text"
                        value={extraColor.cor}
                        onChange={(e) => handleUpdateCorExterna(idx, 'cor', e.target.value)}
                        placeholder="Ex: Gianduia Puro, Carvalho Malva..."
                        className="w-full px-3 py-1.5 bg-white border border-purple-300 rounded-lg text-xs font-medium text-gray-900 focus:ring-2 focus:ring-purple-500"
                      />
                    </div>

                    <button
                      type="button"
                      onClick={() => handleRemoveCorExterna(idx)}
                      className="p-2 text-red-600 hover:text-red-800 hover:bg-red-50 bg-white border border-red-200 rounded-lg self-end md:self-center transition-colors shadow-2xs"
                      title="Remover esta cor adicional"
                    >
                      <Trash2 className="w-3.5 h-3.5" />
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-xs text-gray-500 italic bg-gray-50/70 p-2.5 rounded-lg border border-gray-100">
                Nenhuma cor externa adicional adicionada. Caso este ambiente use mais de uma cor externa, clique no botão acima para incluir.
              </p>
            )}
          </div>
        </div>

        {/* CARD 2: Portas, Aberturas e Puxadores */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 sm:p-6 space-y-5">
          <div className="flex items-center gap-2 pb-3 border-b border-gray-100">
            <DoorOpen className="w-5 h-5 text-[#49943d]" />
            <h3 className="text-base font-bold text-gray-900">2. Portas, Puxadores e Estrutura</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {/* Tipo de Abertura das Portas (Seleção Múltipla / Independente) */}
            <div className="md:col-span-2 space-y-3">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-1">
                <label className="block text-xs font-bold text-gray-700 uppercase tracking-wider">
                  Tipo de Abertura das Portas
                </label>
                <span className="text-[11px] text-gray-500">
                  Você pode selecionar ambos os tipos (Abrir e Correr) para o mesmo ambiente se necessário
                </span>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {/* Toggle Porta de Abrir */}
                <button
                  type="button"
                  onClick={() => handleChange('tem_porta_abrir', !formData.tem_porta_abrir)}
                  className={`py-3 px-4 rounded-xl border text-sm font-semibold flex items-center justify-between transition-all ${
                    formData.tem_porta_abrir
                      ? 'bg-green-50/80 border-[#49943d] text-[#2f6626] ring-1 ring-[#49943d] shadow-2xs'
                      : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                  }`}
                >
                  <div className="flex items-center gap-2">
                    <DoorOpen className={`w-4 h-4 ${formData.tem_porta_abrir ? 'text-[#49943d]' : 'text-gray-400'}`} />
                    <span>Porta de Abrir (Giro)</span>
                  </div>
                  <span className={`text-[11px] px-2.5 py-0.5 rounded-full font-bold ${
                    formData.tem_porta_abrir ? 'bg-[#49943d] text-white' : 'bg-gray-100 text-gray-500'
                  }`}>
                    {formData.tem_porta_abrir ? '✓ Selecionada' : 'Não terá'}
                  </span>
                </button>

                {/* Toggle Porta de Correr */}
                <button
                  type="button"
                  onClick={() => handleChange('tem_porta_correr', !formData.tem_porta_correr)}
                  className={`py-3 px-4 rounded-xl border text-sm font-semibold flex items-center justify-between transition-all ${
                    formData.tem_porta_correr
                      ? 'bg-blue-50/80 border-blue-500 text-blue-900 ring-1 ring-blue-500 shadow-2xs'
                      : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                  }`}
                >
                  <div className="flex items-center gap-2">
                    <Sliders className={`w-4 h-4 ${formData.tem_porta_correr ? 'text-blue-600' : 'text-gray-400'}`} />
                    <span>Porta de Correr (Deslizante)</span>
                  </div>
                  <span className={`text-[11px] px-2.5 py-0.5 rounded-full font-bold ${
                    formData.tem_porta_correr ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-500'
                  }`}>
                    {formData.tem_porta_correr ? '✓ Selecionada' : 'Não terá'}
                  </span>
                </button>
              </div>

              {/* Painéis Condicionais de Ferragens das Portas */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-1">
                {/* Painel Porta de Abrir: Seletor de Dobradiça Automática */}
                {formData.tem_porta_abrir && (
                  <div className="p-4 bg-green-50/40 border border-green-200 rounded-xl space-y-3 animate-fadeIn">
                    <div className="flex items-center justify-between">
                      <label className="block text-xs font-bold text-green-950 uppercase tracking-wider">
                        Dobradiça das Portas de Abrir *
                      </label>
                      <span className="text-[10px] font-semibold text-emerald-800 bg-emerald-100/80 px-2 py-0.5 rounded-full">
                        Automática / Amortecedor
                      </span>
                    </div>

                    <select
                      value={formData.dobradica_tipo || ''}
                      onChange={(e) => handleChange('dobradica_tipo', e.target.value)}
                      className="w-full px-3 py-2 bg-white border border-green-300 rounded-lg text-xs font-semibold text-gray-900 focus:ring-2 focus:ring-[#49943d]"
                    >
                      {DOBRADICAS_OPTIONS.map((opt) => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </select>

                    <div className="pt-0.5">
                      <label className="block text-[11px] font-medium text-gray-600 mb-1">
                        Vincular dobradiça específica do estoque (Opcional):
                      </label>
                      <ProductSearch
                        value={formData.dobradica_produto_id}
                        onChange={(id) => handleChange('dobradica_produto_id', id)}
                        categoria="dobradi"
                        placeholder="Buscar dobradiça cadastrada no estoque..."
                      />
                    </div>
                  </div>
                )}

                {/* Painel Porta de Correr: Seletor de Trilho convencional / Kit Dominus / Sistema Coplanar */}
                {formData.tem_porta_correr && (
                  <div className="p-4 bg-blue-50/40 border border-blue-200 rounded-xl space-y-3 animate-fadeIn">
                    <div className="flex items-center justify-between">
                      <label className="block text-xs font-bold text-blue-950 uppercase tracking-wider">
                        Sistema da Porta de Correr *
                      </label>
                      <span className="text-[10px] font-semibold text-blue-800 bg-blue-100/80 px-2 py-0.5 rounded-full">
                        Ferragens de Deslizamento
                      </span>
                    </div>

                    <div className="space-y-2">
                      {SISTEMAS_CORRER_OPTIONS.map((sis) => {
                        const isSelected = (formData.sistema_correr_tipo || 'Trilho convencional') === sis.value;
                        return (
                          <div
                            key={sis.value}
                            onClick={() => handleChange('sistema_correr_tipo', sis.value)}
                            className={`p-2.5 rounded-lg border cursor-pointer transition-all flex items-start gap-2.5 ${
                              isSelected
                                ? 'bg-white border-blue-500 shadow-2xs ring-1 ring-blue-500 text-blue-950 font-medium'
                                : 'bg-white/80 border-gray-200 text-gray-700 hover:bg-white hover:border-gray-300'
                            }`}
                          >
                            <input
                              type="radio"
                              name="sistema_correr_tipo"
                              checked={isSelected}
                              onChange={() => handleChange('sistema_correr_tipo', sis.value)}
                              className="mt-0.5 w-3.5 h-3.5 text-blue-600 focus:ring-blue-500"
                            />
                            <div className="flex-1 min-w-0">
                              <p className="text-xs font-bold leading-tight">{sis.label}</p>
                              <p className="text-[11px] text-gray-500 mt-0.5 leading-snug">{sis.desc}</p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Acabamento das Portas */}
            <div className="md:col-span-2">
              <label className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">
                Acabamento / Modelo Visual das Portas
              </label>
              <select
                value={formData.modelo_acabamento_portas}
                onChange={(e) => handleChange('modelo_acabamento_portas', e.target.value)}
                className="w-full px-3.5 py-2.5 bg-white border border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-[#49943d]"
              >
                <option value="">Selecione o modelo...</option>
                {(options.modelo_acabamento_portas || [
                  { value: 'Todas retas' },
                  { value: 'Todas provençais' },
                  { value: 'Todas ripadas' },
                  { value: 'Parte inferior provençal e parte superior reta' },
                  { value: 'Parte inferior reta e superior com vidros' },
                  { value: 'Parte superior provençal e parte inferior reta' }
                ]).map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.value}</option>
                ))}
              </select>
            </div>

            {/* Bloco de Puxadores do Estoque (Múltiplas Opções com Informações Ricas igual a Corrediças) */}
            <div className="md:col-span-2 p-4 bg-gray-50 rounded-xl border border-gray-200 space-y-3">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                <div className="flex items-center gap-2">
                  <Sliders className="w-4 h-4 text-[#49943d]" />
                  <label className="block text-xs font-bold text-gray-700 uppercase tracking-wider">
                    Modelo de Puxador (Estoque)
                  </label>
                  {(formData.puxadores_selecionados || []).length > 0 && (
                    <span className="text-[11px] font-semibold text-purple-700 bg-purple-50 px-2 py-0.5 rounded-full border border-purple-200">
                      {formData.puxadores_selecionados.length} modelo{formData.puxadores_selecionados.length !== 1 ? 's' : ''}
                    </span>
                  )}
                </div>
                <span className="text-[11px] text-gray-500">
                  Busque e selecione os puxadores cadastrados no estoque para este ambiente
                </span>
              </div>

              {/* Campo de Busca Autocomplete de Puxadores */}
              <div className="relative">
                <div className="relative flex items-center">
                  <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
                  <input
                    type="text"
                    value={puxadorSearch}
                    onChange={(e) => {
                      setPuxadorSearch(e.target.value);
                      setShowPuxadorDropdown(true);
                    }}
                    onFocus={() => setShowPuxadorDropdown(true)}
                    placeholder="Buscar puxador no estoque (ex: Facetato, Rigore, perfil, concha, ponto)..."
                    className="w-full pl-9 pr-8 py-2 bg-white border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-[#49943d] focus:border-transparent"
                  />
                  {puxadorSearch && (
                    <button
                      type="button"
                      onClick={() => { setPuxadorSearch(''); setShowPuxadorDropdown(false); }}
                      className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-xs"
                    >
                      ✕
                    </button>
                  )}
                </div>

                {/* Dropdown de Resultados da Busca de Puxadores */}
                {showPuxadorDropdown && (puxadorSearch.length >= 2 || availablePuxadores.length > 0) && (
                  <div className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-xl shadow-xl max-h-72 overflow-y-auto divide-y divide-gray-100 animate-fadeIn">
                    {isLoadingPuxadores ? (
                      <div className="p-4 text-center text-xs text-gray-500 flex items-center justify-center gap-2">
                        <div className="w-4 h-4 border-2 border-[#49943d] border-t-transparent rounded-full animate-spin" />
                        <span>Buscando puxadores no estoque...</span>
                      </div>
                    ) : availablePuxadores.length === 0 ? (
                      <div className="p-4 text-center text-xs text-gray-500">
                        Nenhum puxador encontrado para "{puxadorSearch}".
                      </div>
                    ) : (
                      availablePuxadores.map((variante) => {
                        const hasImg = Boolean(variante.imagem_url);
                        return (
                          <button
                            key={variante.id}
                            type="button"
                            onClick={() => handleAddPuxador(variante)}
                            className="w-full p-3 text-left hover:bg-green-50/50 transition-colors flex items-center gap-3"
                          >
                            {/* Miniatura ou Ícone */}
                            <div className="w-12 h-12 rounded-lg border border-gray-200 bg-gray-50 flex items-center justify-center flex-shrink-0 overflow-hidden relative">
                              {hasImg ? (
                                <img
                                  src={variante.imagem_url}
                                  alt={variante.produto_nome}
                                  className="w-full h-full object-cover"
                                />
                              ) : (
                                <Box className="w-6 h-6 text-gray-400" />
                              )}
                            </div>

                            {/* Informações Ricas */}
                            <div className="flex-1 min-w-0">
                              <p className="text-xs font-bold text-gray-900 truncate">
                                {variante.produto_nome}
                              </p>
                              <div className="flex flex-wrap items-center gap-1.5 mt-0.5 text-[11px] text-gray-500">
                                {variante.cor && (
                                  <span className="font-semibold text-purple-800 bg-purple-50 px-1.5 py-0.2 rounded border border-purple-200">
                                    Cor: {variante.cor}
                                  </span>
                                )}
                                {(variante.medida_text || variante.tamanho_label) && (
                                  <span className="font-bold text-emerald-800 bg-emerald-50 px-1.5 py-0.2 rounded border border-emerald-200">
                                    📏 {variante.medida_text || variante.tamanho_label}
                                  </span>
                                )}
                                {variante.marca_nome && (
                                  <span className="bg-gray-100 text-gray-700 px-1.5 py-0.2 rounded">
                                    Marca: {variante.marca_nome}
                                  </span>
                                )}
                                <span className="font-mono text-gray-600">
                                  SKU: {variante.sku_variacao || '-'}
                                </span>
                              </div>
                              {variante.fornecedores_precos && variante.fornecedores_precos.length > 0 && (
                                <p className="text-[10px] text-purple-700 mt-0.5 truncate">
                                  🏢 Fornecedor: {variante.fornecedores_precos[0].fornecedor_nome}
                                </p>
                              )}
                            </div>

                            {/* Preço e Estoque */}
                            <div className="text-right flex-shrink-0">
                              <p className="text-xs font-extrabold text-emerald-700">
                                {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(variante.preco_venda || variante.preco_custo || 0)}
                              </p>
                              <p className="text-[10px] text-gray-400">
                                Estoque: <strong className="text-gray-700 font-semibold">{variante.estoque_disponivel ?? variante.estoque_total ?? 0}</strong>
                              </p>
                            </div>
                          </button>
                        );
                      })
                    )}
                  </div>
                )}
              </div>

              {/* Lista de Puxadores Selecionados no Ambiente */}
              {(formData.puxadores_selecionados || []).length > 0 ? (
                <div className="space-y-2.5 pt-1">
                  {formData.puxadores_selecionados.map((puxador, idx) => (
                    <div
                      key={puxador.id || idx}
                      className="p-3 bg-white border border-gray-200 rounded-xl shadow-2xs flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3 animate-fadeIn"
                    >
                      <div className="flex items-center gap-3 min-w-0">
                        {/* Imagem do Puxador com clique para Zoom */}
                        <div
                          onClick={() => puxador.imagem_url && setSelectedZoomImage(puxador.imagem_url)}
                          className={`w-12 h-12 rounded-lg border border-gray-200 bg-gray-50 flex items-center justify-center flex-shrink-0 overflow-hidden relative ${
                            puxador.imagem_url ? 'cursor-pointer hover:opacity-90 group' : ''
                          }`}
                          title={puxador.imagem_url ? 'Clique para ampliar imagem' : 'Sem foto'}
                        >
                          {puxador.imagem_url ? (
                            <>
                              <img
                                src={puxador.imagem_url}
                                alt={puxador.produto_nome}
                                className="w-full h-full object-cover"
                              />
                              <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity">
                                <ZoomIn className="w-4 h-4 text-white" />
                              </div>
                            </>
                          ) : (
                            <Box className="w-6 h-6 text-gray-400" />
                          )}
                        </div>

                        <div className="min-w-0">
                          <p className="text-xs font-bold text-gray-900 truncate">
                            {puxador.produto_nome}
                          </p>
                          <div className="flex flex-wrap items-center gap-1.5 mt-0.5 text-[11px]">
                            {puxador.cor && (
                              <span className="font-semibold text-purple-800 bg-purple-50 px-1.5 py-0.2 rounded border border-purple-200">
                                Cor: {puxador.cor}
                              </span>
                            )}
                            {(puxador.medida_text || puxador.tamanho_label) && (
                              <span className="font-bold text-emerald-800 bg-emerald-50 px-1.5 py-0.2 rounded border border-emerald-200">
                                📏 {puxador.medida_text || puxador.tamanho_label}
                              </span>
                            )}
                            {puxador.marca_nome && (
                              <span className="bg-gray-100 text-gray-700 px-1.5 py-0.2 rounded">
                                {puxador.marca_nome}
                              </span>
                            )}
                            {puxador.sku_variacao && (
                              <span className="font-mono text-gray-500">
                                {puxador.sku_variacao}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Campos: Quantidade e Aplicação */}
                      <div className="flex items-center gap-2.5 self-end sm:self-auto flex-wrap sm:flex-nowrap">
                        <div className="flex items-center gap-1.5">
                          <label className="text-[11px] font-semibold text-gray-600 whitespace-nowrap">
                            Qtd:
                          </label>
                          <input
                            type="number"
                            min="1"
                            value={puxador.quantidade || 1}
                            onChange={(e) => handleUpdatePuxador(idx, 'quantidade', Math.max(1, parseInt(e.target.value) || 1))}
                            className="w-16 px-2 py-1 text-xs border border-gray-300 rounded-lg text-center font-bold bg-white focus:ring-1 focus:ring-[#49943d]"
                            title="Quantidade de puxadores"
                          />
                        </div>

                        <div className="flex items-center gap-1.5">
                          <input
                            type="text"
                            value={puxador.aplicacao || ''}
                            onChange={(e) => handleUpdatePuxador(idx, 'aplicacao', e.target.value)}
                            placeholder="Aplicação (ex: Portas inferiores, Aéreos)..."
                            className="w-44 px-2.5 py-1 text-xs border border-gray-300 rounded-lg bg-white focus:ring-1 focus:ring-[#49943d]"
                            title="Onde este puxador será usado no ambiente"
                          />
                        </div>

                        <button
                          type="button"
                          onClick={() => handleRemovePuxador(idx)}
                          className="p-1.5 text-red-600 hover:text-red-800 hover:bg-red-50 bg-white border border-red-200 rounded-lg transition-colors shadow-2xs"
                          title="Remover puxador"
                        >
                          <Trash2 className="w-3.5 h-3.5" />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-xs text-gray-500 italic bg-white/70 p-2.5 rounded-lg border border-gray-200">
                  Nenhum puxador selecionado do estoque. Utilize o campo de busca acima ou marque as opções abaixo.
                </p>
              )}

              {/* Opções especiais de abertura (Cava e Fecho-Toque) */}
              <div className="pt-2 flex flex-wrap items-center gap-4 border-t border-gray-200">
                <label className="inline-flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData.puxador_cava}
                    onChange={(e) => handleChange('puxador_cava', e.target.checked)}
                    className="w-4 h-4 text-[#49943d] rounded focus:ring-[#49943d]"
                  />
                  <span className="text-xs sm:text-sm font-medium text-gray-700">
                    Puxador Cava (usinado diretamente no MDF)
                  </span>
                </label>

                <label className="inline-flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData.puxador_fecho_toque}
                    onChange={(e) => handleChange('puxador_fecho_toque', e.target.checked)}
                    className="w-4 h-4 text-[#49943d] rounded focus:ring-[#49943d]"
                  />
                  <span className="text-xs sm:text-sm font-medium text-gray-700">
                    Sem Puxador / Fecho-Toque (Pulsador Magnético Tip-On)
                  </span>
                </label>
              </div>
            </div>

            {/* Bloco de Corrediças do Estoque (Múltiplas Opções com Informações Ricas) */}
            <div className="md:col-span-2 p-4 bg-gray-50 rounded-xl border border-gray-200 space-y-3">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                <div className="flex items-center gap-2">
                  <Sliders className="w-4 h-4 text-[#49943d]" />
                  <label className="block text-xs font-bold text-gray-700 uppercase tracking-wider">
                    Corrediças das Gavetas (Estoque)
                  </label>
                  {(formData.corredicas_selecionadas || []).length > 0 && (
                    <span className="text-[11px] font-semibold text-purple-700 bg-purple-50 px-2 py-0.5 rounded-full border border-purple-200">
                      {formData.corredicas_selecionadas.length} modelo{formData.corredicas_selecionadas.length !== 1 ? 's' : ''}
                    </span>
                  )}
                </div>
                <span className="text-[11px] text-gray-500">
                  Você pode selecionar mais de uma medida ou modelo para este ambiente
                </span>
              </div>

              {/* Campo de Busca Autocomplete de Corrediças */}
              <div className="relative">
                <div className="relative flex items-center">
                  <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
                  <input
                    type="text"
                    value={corredicaSearch}
                    onChange={(e) => {
                      setCorredicaSearch(e.target.value);
                      setShowCorredicaDropdown(true);
                    }}
                    onFocus={() => setShowCorredicaDropdown(true)}
                    placeholder="Buscar corrediça no estoque (ex: 25cm, 35cm, oculta, telescópica)..."
                    className="w-full pl-9 pr-8 py-2 bg-white border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-[#49943d] focus:border-transparent"
                  />
                  {corredicaSearch && (
                    <button
                      type="button"
                      onClick={() => { setCorredicaSearch(''); setShowCorredicaDropdown(false); }}
                      className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-xs"
                    >
                      ✕
                    </button>
                  )}
                </div>

                {/* Dropdown de Resultados da Busca com Imagem e Detalhes */}
                {showCorredicaDropdown && (corredicaSearch.length >= 2 || availableCorredicas.length > 0) && (
                  <div className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-xl shadow-xl max-h-72 overflow-y-auto divide-y divide-gray-100 animate-fadeIn">
                    {isLoadingCorredicas ? (
                      <div className="p-4 text-center text-xs text-gray-500 flex items-center justify-center gap-2">
                        <div className="w-4 h-4 border-2 border-[#49943d] border-t-transparent rounded-full animate-spin" />
                        <span>Buscando corrediças no estoque...</span>
                      </div>
                    ) : availableCorredicas.length === 0 ? (
                      <div className="p-4 text-center text-xs text-gray-500">
                        Nenhuma corrediça encontrada para "{corredicaSearch}".
                      </div>
                    ) : (
                      availableCorredicas.map((variante) => {
                        const hasImg = Boolean(variante.imagem_url);
                        return (
                          <button
                            key={variante.id}
                            type="button"
                            onClick={() => handleAddCorredica(variante)}
                            className="w-full p-3 text-left hover:bg-green-50/50 transition-colors flex items-center gap-3"
                          >
                            {/* Miniatura ou Ícone */}
                            <div className="w-12 h-12 rounded-lg border border-gray-200 bg-gray-50 flex items-center justify-center flex-shrink-0 overflow-hidden relative group">
                              {hasImg ? (
                                <img
                                  src={variante.imagem_url}
                                  alt={variante.produto_nome}
                                  className="w-full h-full object-cover"
                                />
                              ) : (
                                <Box className="w-6 h-6 text-gray-400" />
                              )}
                            </div>

                            {/* Informações Ricas */}
                            <div className="flex-1 min-w-0">
                              <p className="text-xs font-bold text-gray-900 truncate">
                                {variante.produto_nome}
                              </p>
                              <div className="flex flex-wrap items-center gap-1.5 mt-0.5 text-[11px] text-gray-500">
                                {(variante.medida_text || variante.tamanho_label) && (
                                  <span className="font-bold text-emerald-800 bg-emerald-50 px-1.5 py-0.2 rounded border border-emerald-200">
                                    📏 {variante.medida_text || variante.tamanho_label}
                                  </span>
                                )}
                                {variante.marca_nome && (
                                  <span className="bg-gray-100 text-gray-700 px-1.5 py-0.2 rounded">
                                    Marca: {variante.marca_nome}
                                  </span>
                                )}
                                <span className="font-mono text-gray-600">
                                  SKU: {variante.sku_variacao || '-'}
                                </span>
                              </div>
                              {variante.fornecedores_precos && variante.fornecedores_precos.length > 0 && (
                                <p className="text-[10px] text-purple-700 mt-0.5 truncate">
                                  🏢 Fornecedor: {variante.fornecedores_precos[0].fornecedor_nome}
                                </p>
                              )}
                            </div>

                            {/* Preço e Estoque */}
                            <div className="text-right flex-shrink-0">
                              <p className="text-xs font-extrabold text-emerald-700">
                                {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(variante.preco_venda || variante.preco_custo || 0)}
                              </p>
                              <p className="text-[10px] text-gray-400">
                                Estoque: <strong className="text-gray-700 font-semibold">{variante.estoque_disponivel ?? variante.estoque_total ?? 0}</strong>
                              </p>
                            </div>
                          </button>
                        );
                      })
                    )}
                  </div>
                )}
              </div>

              {/* Lista de Corrediças Selecionadas no Ambiente */}
              {(formData.corredicas_selecionadas || []).length > 0 ? (
                <div className="space-y-2.5 pt-1">
                  {formData.corredicas_selecionadas.map((corredica, idx) => (
                    <div
                      key={corredica.id || idx}
                      className="p-3 bg-white border border-gray-200 rounded-xl shadow-2xs flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3 animate-fadeIn"
                    >
                      <div className="flex items-center gap-3 min-w-0">
                        {/* Imagem do Produto com clique para Zoom */}
                        <div
                          onClick={() => corredica.imagem_url && setSelectedZoomImage(corredica.imagem_url)}
                          className={`w-12 h-12 rounded-lg border border-gray-200 bg-gray-50 flex items-center justify-center flex-shrink-0 overflow-hidden relative ${
                            corredica.imagem_url ? 'cursor-pointer hover:opacity-90 group' : ''
                          }`}
                          title={corredica.imagem_url ? 'Clique para ampliar imagem' : 'Sem foto'}
                        >
                          {corredica.imagem_url ? (
                            <>
                              <img
                                src={corredica.imagem_url}
                                alt={corredica.produto_nome}
                                className="w-full h-full object-cover"
                              />
                              <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity">
                                <ZoomIn className="w-4 h-4 text-white" />
                              </div>
                            </>
                          ) : (
                            <Box className="w-6 h-6 text-gray-400" />
                          )}
                        </div>

                        <div className="min-w-0">
                          <p className="text-xs font-bold text-gray-900 truncate">
                            {corredica.produto_nome}
                          </p>
                          <div className="flex flex-wrap items-center gap-1.5 mt-0.5 text-[11px]">
                            {(corredica.medida_text || corredica.tamanho_label) && (
                              <span className="font-bold text-emerald-800 bg-emerald-50 px-1.5 py-0.2 rounded border border-emerald-200">
                                📏 {corredica.medida_text || corredica.tamanho_label}
                              </span>
                            )}
                            {corredica.marca_nome && (
                              <span className="bg-gray-100 text-gray-700 px-1.5 py-0.2 rounded">
                                {corredica.marca_nome}
                              </span>
                            )}
                            {corredica.fornecedor_nome && (
                              <span className="text-purple-700 text-[10px]">
                                ({corredica.fornecedor_nome})
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Campos: Quantidade de Pares e Aplicação */}
                      <div className="flex items-center gap-2.5 self-end sm:self-auto flex-wrap sm:flex-nowrap">
                        <div className="flex items-center gap-1.5">
                          <label className="text-[11px] font-semibold text-gray-600 whitespace-nowrap">
                            Pares:
                          </label>
                          <input
                            type="number"
                            min="1"
                            value={corredica.pares_qtd || 1}
                            onChange={(e) => handleUpdateCorredica(idx, 'pares_qtd', Math.max(1, parseInt(e.target.value) || 1))}
                            className="w-16 px-2 py-1 text-xs border border-gray-300 rounded-lg text-center font-bold bg-white focus:ring-1 focus:ring-[#49943d]"
                            title="Quantidade de pares de corrediças"
                          />
                        </div>

                        <div className="flex items-center gap-1.5">
                          <input
                            type="text"
                            value={corredica.aplicacao || ''}
                            onChange={(e) => handleUpdateCorredica(idx, 'aplicacao', e.target.value)}
                            placeholder="Aplicação (ex: Gavetões, Talheres)..."
                            className="w-44 px-2.5 py-1 text-xs border border-gray-300 rounded-lg bg-white focus:ring-1 focus:ring-[#49943d]"
                            title="Onde esta corrediça será usada no armário"
                          />
                        </div>

                        <button
                          type="button"
                          onClick={() => handleRemoveCorredica(idx)}
                          className="p-1.5 text-red-600 hover:text-red-800 hover:bg-red-50 bg-white border border-red-200 rounded-lg transition-colors shadow-2xs"
                          title="Remover corrediça"
                        >
                          <Trash2 className="w-3.5 h-3.5" />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-xs text-gray-500 italic bg-white/70 p-2.5 rounded-lg border border-gray-200">
                  Nenhuma corrediça selecionada. Use a busca acima para vincular corrediças do estoque a este ambiente.
                </p>
              )}
            </div>

            {/* Modelo do Corpo do Armário */}
            <div className="md:col-span-2">
              <label className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2">
                Modelo do Corpo do Armário (Caixaria) *
              </label>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                {CORPO_ARMARIO_OPTIONS.map((opt) => {
                  const isSelected = formData.modelo_corpo === opt.value;
                  return (
                    <div
                      key={opt.value}
                      onClick={() => handleChange('modelo_corpo', opt.value)}
                      className={`p-3.5 rounded-xl border-2 cursor-pointer transition-all ${
                        isSelected
                          ? 'border-[#49943d] bg-green-50/50 shadow-sm'
                          : 'border-gray-200 bg-white hover:border-gray-300'
                      }`}
                    >
                      <div className="flex items-center justify-between mb-1">
                        <span className="font-bold text-sm text-gray-900">{opt.label}</span>
                        {isSelected && <Check className="w-4 h-4 text-[#49943d]" />}
                      </div>
                      <p className="text-xs text-gray-500 leading-snug">{opt.desc}</p>
                    </div>
                  );
                })}
              </div>
              {errors.modelo_corpo && (
                <p className="text-xs text-red-600 mt-1.5 font-medium">{errors.modelo_corpo}</p>
              )}
            </div>
          </div>
        </div>

        {/* CARD 3: Iluminação e Acabamento Inferior (SEÇÃO ÚNICA - SEM DUPLICIDADES) */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 sm:p-6 space-y-6">
          <div className="flex items-center gap-2 pb-3 border-b border-gray-100">
            <Lightbulb className="w-5 h-5 text-[#49943d]" />
            <h3 className="text-base font-bold text-gray-900">3. Iluminação & Acabamento Inferior</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Bloco de Fita de LED - ÚNICO */}
            <div className="p-4 bg-gray-50 rounded-xl border border-gray-200 space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <h4 className="text-sm font-bold text-gray-900">Fita de LED</h4>
                  <p className="text-xs text-gray-500">Instalação de perfil de iluminação no armário</p>
                </div>
                <button
                  type="button"
                  onClick={() => handleChange('has_fita_led', !formData.has_fita_led)}
                  className={`px-3 py-1.5 rounded-lg text-xs font-bold border transition-all ${
                    formData.has_fita_led
                      ? 'bg-[#49943d] text-white border-[#49943d] shadow-sm'
                      : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100'
                  }`}
                >
                  {formData.has_fita_led ? 'Sim, terá LED' : 'Não terá LED'}
                </button>
              </div>

              {formData.has_fita_led && (
                <div className="space-y-3 pt-3 border-t border-gray-200/80 animate-fadeIn">
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      Local de Instalação do LED
                    </label>
                    <input
                      type="text"
                      value={formData.fita_led_local}
                      onChange={(e) => handleChange('fita_led_local', e.target.value)}
                      placeholder="Ex: Sob o armário aéreo, nicho decorativo..."
                      className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-[#49943d]"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      Cor da Canaleta de Alumínio
                    </label>
                    <select
                      value={formData.fita_led_cor}
                      onChange={(e) => handleChange('fita_led_cor', e.target.value)}
                      className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-[#49943d]"
                    >
                      <option value="">Selecione a cor...</option>
                      <option value="Preta">Preta</option>
                      <option value="Bronze">Bronze</option>
                      <option value="Prata">Prata</option>
                      <option value="Branca">Branca</option>
                    </select>
                  </div>
                </div>
              )}
            </div>

            {/* Bloco de Acabamento Inferior - ÚNICO */}
            <div className="p-4 bg-gray-50 rounded-xl border border-gray-200 space-y-3">
              <div>
                <h4 className="text-sm font-bold text-gray-900">Modelo Acabamento Inferior</h4>
                <p className="text-xs text-gray-500">Como a base do móvel se apoiará no chão</p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 pt-1">
                {ACABAMENTO_INFERIOR_OPTIONS.map((opt) => {
                  const isSelected = formData.modelo_acabamento_inferior === opt.value;
                  return (
                    <button
                      key={opt.value}
                      type="button"
                      onClick={() => handleChange('modelo_acabamento_inferior', opt.value)}
                      className={`p-2.5 rounded-xl border text-left transition-all ${
                        isSelected
                          ? 'border-[#49943d] bg-green-50 text-[#2f6626] ring-1 ring-[#49943d] shadow-2xs'
                          : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-100 hover:border-gray-300'
                      }`}
                    >
                      <div className="font-semibold text-xs">{opt.label}</div>
                      <div className="text-[10px] text-gray-500 mt-0.5 line-clamp-1">{opt.desc}</div>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* CARD 4: Portas de Vidro e Esquadrias */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 sm:p-6 space-y-5">
          <div className="flex items-center justify-between pb-3 border-b border-gray-100">
            <div className="flex items-center gap-2">
              <Sparkles className="w-5 h-5 text-[#49943d]" />
              <h3 className="text-base font-bold text-gray-900">4. Portas de Vidro / Reflecta</h3>
            </div>
            <div className="flex items-center gap-2">
              {['NAO', 'SIM'].map((val) => (
                <button
                  key={val}
                  type="button"
                  onClick={() => handleChange('porta_vidro', val)}
                  className={`px-3 py-1 text-xs font-bold rounded-lg border transition-all ${
                    formData.porta_vidro === val
                      ? 'bg-[#49943d] text-white border-[#49943d]'
                      : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                  }`}
                >
                  {val === 'SIM' ? 'Possui Vidro' : 'Não Possui'}
                </button>
              ))}
            </div>
          </div>

          {formData.porta_vidro === 'SIM' && (
            <div className="p-4 bg-purple-50/50 rounded-xl border border-purple-200 grid grid-cols-1 sm:grid-cols-2 gap-4 animate-fadeIn">
              <div className="sm:col-span-2">
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Quais portas terão vidro? (Localização)
                </label>
                <input
                  type="text"
                  value={formData.porta_vidro_local}
                  onChange={(e) => handleChange('porta_vidro_local', e.target.value)}
                  placeholder="Ex: Cristaleira superior direita, armário aéreo central..."
                  className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-purple-500"
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Modelo do Vidro</label>
                <select
                  value={formData.porta_vidro_modelo}
                  onChange={(e) => handleChange('porta_vidro_modelo', e.target.value)}
                  className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-purple-500"
                >
                  <option value="">Selecione o acabamento do vidro...</option>
                  {VIDRO_MODELOS.map(opt => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Cor do Perfil de Alumínio</label>
                <select
                  value={formData.porta_vidro_cor_armacao}
                  onChange={(e) => handleChange('porta_vidro_cor_armacao', e.target.value)}
                  className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-purple-500"
                >
                  <option value="">Selecione a cor do perfil...</option>
                  {VIDRO_PERFIL_CORES.map(opt => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              </div>

              <div className="sm:col-span-2 pt-1">
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Puxador específico para porta de vidro (Opcional)
                </label>
                <ProductSearch
                  value={formData.puxador_vidro_produto_id}
                  onChange={(id) => handleChange('puxador_vidro_produto_id', id)}
                  categoria="puxad"
                  placeholder="Buscar puxador de perfil/vidro no estoque..."
                />
              </div>
            </div>
          )}
        </div>

        {/* CARD 5: Acessórios, Painéis e Serralheria */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 sm:p-6 space-y-6">
          <div className="flex items-center gap-2 pb-3 border-b border-gray-100">
            <Sliders className="w-5 h-5 text-[#49943d]" />
            <h3 className="text-base font-bold text-gray-900">5. Acessórios e Detalhes Especiais</h3>
          </div>

          {/* Cabideiros (Comum, Iluminado, Extensivo) */}
          <div>
            <h4 className="text-xs font-bold text-gray-700 uppercase tracking-wider mb-2.5">
              Tubos Cabideiros (Guarda-roupas / Closets)
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              {[
                { key: 'cabide_comum', qtdKey: 'cabide_comum_qtd', label: 'Cabideiro Comum' },
                { key: 'cabide_iluminado', qtdKey: 'cabide_iluminado_qtd', label: 'Cabideiro Iluminado' },
                { key: 'cabide_extensivo', qtdKey: 'cabide_extensivo_qtd', label: 'Cabideiro Extensivo (Basculante)' }
              ].map(item => {
                const isChecked = Boolean(formData[item.key]);
                return (
                  <div
                    key={item.key}
                    className={`p-3 rounded-xl border transition-all ${
                      isChecked ? 'bg-green-50/60 border-[#49943d]' : 'bg-gray-50 border-gray-200'
                    }`}
                  >
                    <label className="flex items-center gap-2 cursor-pointer mb-2">
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e) => handleChange(item.key, e.target.checked)}
                        className="w-4 h-4 text-[#49943d] rounded"
                      />
                      <span className="text-xs font-bold text-gray-800">{item.label}</span>
                    </label>
                    {isChecked && (
                      <div className="flex items-center gap-2 pl-6">
                        <span className="text-xs text-gray-500">Qtd:</span>
                        <input
                          type="number"
                          min="1"
                          value={formData[item.qtdKey] || 1}
                          onChange={(e) => handleChange(item.qtdKey, Math.max(1, parseInt(e.target.value) || 1))}
                          className="w-16 px-2 py-1 text-xs border border-gray-300 rounded bg-white text-center font-bold"
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 pt-2 border-t border-gray-100">
            {/* Painéis na Parede */}
            <div>
              <h4 className="text-xs font-bold text-gray-700 uppercase tracking-wider mb-2">
                Painéis Ripados / Lisos na Parede
              </h4>
              <div className="space-y-2">
                <label className="flex items-center gap-2 p-2.5 bg-gray-50 rounded-xl border border-gray-200 cursor-pointer hover:bg-gray-100">
                  <input
                    type="checkbox"
                    checked={formData.painel_roda_pe}
                    onChange={(e) => handleChange('painel_roda_pe', e.target.checked)}
                    className="w-4 h-4 text-[#49943d] rounded"
                  />
                  <span className="text-xs text-gray-800 font-medium">Acima do rodapé</span>
                </label>
                <label className="flex items-center gap-2 p-2.5 bg-gray-50 rounded-xl border border-gray-200 cursor-pointer hover:bg-gray-100">
                  <input
                    type="checkbox"
                    checked={formData.painel_suspenso_bigarrilo}
                    onChange={(e) => handleChange('painel_suspenso_bigarrilo', e.target.checked)}
                    className="w-4 h-4 text-[#49943d] rounded"
                  />
                  <span className="text-xs text-gray-800 font-medium">Até o chão, suspenso apenas com bigarrilo</span>
                </label>
              </div>
            </div>

            {/* Cortineiro & Ferragens de Serralheria */}
            <div className="space-y-4">
              <div>
                <h4 className="text-xs font-bold text-gray-700 uppercase tracking-wider mb-2">
                  Atenção com Cortineiro na Execução?
                </h4>
                <div className="flex gap-2">
                  {['SIM', 'NAO'].map(opt => (
                    <button
                      key={opt}
                      type="button"
                      onClick={() => handleChange('tem_cortineiro', opt)}
                      className={`flex-1 py-1.5 text-xs font-semibold rounded-lg border ${
                        formData.tem_cortineiro === opt
                          ? 'bg-[#49943d] text-white border-[#49943d]'
                          : 'bg-white text-gray-700 border-gray-300'
                      }`}
                    >
                      {opt === 'SIM' ? 'Sim, atentar ao cortineiro' : 'Não'}
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <h4 className="text-xs font-bold text-gray-700 uppercase tracking-wider mb-2">
                  Estruturas / Ferragens de Serralheria
                </h4>
                <div className="flex gap-2 mb-2">
                  {['SIM', 'NAO'].map(opt => (
                    <button
                      key={opt}
                      type="button"
                      onClick={() => handleChange('tem_ferragens_serralheria', opt)}
                      className={`flex-1 py-1.5 text-xs font-semibold rounded-lg border ${
                        formData.tem_ferragens_serralheria === opt
                          ? 'bg-[#49943d] text-white border-[#49943d]'
                          : 'bg-white text-gray-700 border-gray-300'
                      }`}
                    >
                      {opt === 'SIM' ? 'Sim, possui serralheria' : 'Não'}
                    </button>
                  ))}
                </div>

                {formData.tem_ferragens_serralheria === 'SIM' && (
                  <div className="grid grid-cols-2 gap-2 p-2.5 bg-gray-50 rounded-xl border border-gray-200">
                    <input
                      type="text"
                      value={formData.ferragens_local}
                      onChange={(e) => handleChange('ferragens_local', e.target.value)}
                      placeholder="Local da serralheria..."
                      className="px-2.5 py-1.5 bg-white border border-gray-300 rounded-lg text-xs"
                    />
                    <select
                      value={formData.ferragens_cor}
                      onChange={(e) => handleChange('ferragens_cor', e.target.value)}
                      className="px-2.5 py-1.5 bg-white border border-gray-300 rounded-lg text-xs"
                    >
                      <option value="">Cor...</option>
                      {SERRALHERIA_CORES.map(c => (
                        <option key={c} value={c}>{c}</option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* CARD 6: Itens Embutidos na Marcenaria */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 sm:p-6 space-y-4">
          <div className="flex items-center justify-between pb-3 border-b border-gray-100">
            <div className="flex items-center gap-2">
              <Box className="w-5 h-5 text-[#49943d]" />
              <div>
                <h3 className="text-base font-bold text-gray-900">6. Eletros e Itens Embutidos</h3>
                <p className="text-xs text-gray-500">Marque quais itens serão encaixados na marcenaria</p>
              </div>
            </div>
          </div>

          {/* Adicionar novo item */}
          <div className="flex gap-2">
            <input
              type="text"
              value={newEmbeddedItem}
              onChange={(e) => setNewEmbeddedItem(e.target.value)}
              placeholder="Cadastrar novo eletro/item (ex: Micro-ondas, Adega)..."
              className="flex-1 px-3.5 py-2 border border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-[#49943d]"
              onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), handleAddEmbeddedItem())}
            />
            <button
              type="button"
              onClick={handleAddEmbeddedItem}
              disabled={createEmbeddedMutation.isPending || !newEmbeddedItem.trim()}
              className="px-4 py-2 bg-[#49943d] hover:bg-[#3a7630] text-white rounded-xl text-xs font-bold flex items-center gap-1.5 disabled:opacity-50 transition-colors shadow-sm"
            >
              <Plus className="w-4 h-4" />
              <span>Adicionar</span>
            </button>
          </div>

          {/* Grid de Itens */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 pt-2">
            {(embeddedItems || []).map(item => {
              const isChecked = (formData.itens_embutidos || []).includes(item.id);
              const detail = (formData.itens_embutidos_detalhes || {})[item.id] || {};

              return (
                <div
                  key={item.id}
                  className={`p-3 rounded-xl border transition-all ${
                    isChecked
                      ? 'bg-green-50/70 border-[#49943d] shadow-2xs'
                      : 'bg-gray-50/60 border-gray-200 text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <label className="flex items-center gap-2 flex-1 cursor-pointer truncate">
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e) => {
                          const current = formData.itens_embutidos || [];
                          const newList = e.target.checked
                            ? [...current, item.id]
                            : current.filter(id => id !== item.id);
                          handleChange('itens_embutidos', newList);
                        }}
                        className="w-4 h-4 text-[#49943d] rounded"
                      />
                      <span className={`text-xs font-semibold truncate ${isChecked ? 'text-[#2f6626]' : 'text-gray-800'}`}>
                        {item.name}
                      </span>
                    </label>
                    <button
                      type="button"
                      onClick={() => handleDeleteEmbeddedItem(item.id)}
                      className="text-gray-400 hover:text-red-600 p-1 rounded transition-colors"
                      title="Remover item da lista"
                    >
                      <X className="w-3.5 h-3.5" />
                    </button>
                  </div>

                  {/* Campos de Dimensões Aproximadas do Eletro */}
                  {isChecked && (
                    <div className="mt-2.5 pt-2.5 border-t border-green-200/80 space-y-2 animate-fadeIn">
                      <div className="flex items-center justify-between gap-1 text-[10px] font-bold text-[#2f6626] uppercase">
                        <span>Dimensões do Nicho / Vão (cm)</span>
                      </div>
                      <div className="grid grid-cols-3 gap-1.5">
                        <div>
                          <input
                            type="number"
                            step="0.1"
                            value={detail.largura || ''}
                            onChange={(e) => handleUpdateEmbeddedItemDetail(item.id, 'largura', e.target.value)}
                            placeholder="Largura"
                            className="w-full px-2 py-1 bg-white border border-green-300 rounded text-xs text-center font-medium focus:ring-1 focus:ring-[#49943d]"
                            title="Largura em cm"
                          />
                        </div>
                        <div>
                          <input
                            type="number"
                            step="0.1"
                            value={detail.altura || ''}
                            onChange={(e) => handleUpdateEmbeddedItemDetail(item.id, 'altura', e.target.value)}
                            placeholder="Altura"
                            className="w-full px-2 py-1 bg-white border border-green-300 rounded text-xs text-center font-medium focus:ring-1 focus:ring-[#49943d]"
                            title="Altura em cm"
                          />
                        </div>
                        <div>
                          <input
                            type="number"
                            step="0.1"
                            value={detail.profundidade || ''}
                            onChange={(e) => handleUpdateEmbeddedItemDetail(item.id, 'profundidade', e.target.value)}
                            placeholder="Prof."
                            className="w-full px-2 py-1 bg-white border border-green-300 rounded text-xs text-center font-medium focus:ring-1 focus:ring-[#49943d]"
                            title="Profundidade em cm"
                          />
                        </div>
                      </div>
                      <input
                        type="text"
                        value={detail.modelo || ''}
                        onChange={(e) => handleUpdateEmbeddedItemDetail(item.id, 'modelo', e.target.value)}
                        placeholder="Marca / Modelo (ex: Brastemp 82L)"
                        className="w-full px-2 py-1 bg-white border border-green-300 rounded text-xs font-normal text-gray-800 focus:ring-1 focus:ring-[#49943d]"
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* CARD 7: Observações Finais */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 sm:p-6 space-y-3">
          <div className="flex items-center gap-2 pb-2 border-b border-gray-100">
            <HelpCircle className="w-5 h-5 text-gray-500" />
            <h3 className="text-base font-bold text-gray-900">7. Observações Técnicas Gerais</h3>
          </div>
          <textarea
            value={formData.observacoes}
            onChange={(e) => handleChange('observacoes', e.target.value)}
            rows={3}
            className="w-full px-3.5 py-2.5 border border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-[#49943d] resize-none"
            placeholder="Orientações adicionais para a produção, restrições no ambiente ou preferências do cliente..."
          />
        </div>

        {/* Barra de Ações Inferior */}
        <div className="flex items-center justify-end gap-3 pt-2">
          {onCancel && (
            <button
              type="button"
              onClick={onCancel}
              className="px-6 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-xl hover:bg-gray-50 transition-colors shadow-2xs"
            >
              Cancelar
            </button>
          )}
          <button
            type="submit"
            disabled={saveMutation.isPending}
            className="px-8 py-2.5 text-sm font-bold text-white bg-[#49943d] hover:bg-[#3a7630] rounded-xl shadow-md hover:shadow-lg transition-all flex items-center gap-2 disabled:opacity-50"
          >
            <Save className="w-4 h-4" />
            <span>{saveMutation.isPending ? 'Salvando Ficha...' : 'Salvar Ficha de Orçamento'}</span>
          </button>
        </div>
      </form>

      <ConfirmModal
        show={confirmState.show}
        message={confirmState.message}
        onConfirm={confirmState.onConfirm}
        onCancel={() => setConfirmState({ show: false, onConfirm: null, message: '' })}
        title="Confirmar Exclusão"
        confirmText="Remover"
        cancelText="Cancelar"
        type="warning"
      />

      {/* Modal de Zoom de Imagem da Corrediça/Produto */}
      {selectedZoomImage && (
        <div
          onClick={() => setSelectedZoomImage(null)}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/75 backdrop-blur-xs p-4 cursor-pointer animate-fadeIn"
        >
          <div className="relative max-w-lg max-h-[85vh] bg-white rounded-2xl overflow-hidden p-2 shadow-2xl">
            <button
              type="button"
              onClick={() => setSelectedZoomImage(null)}
              className="absolute top-3 right-3 p-1.5 bg-black/60 text-white rounded-full hover:bg-black/80 transition-colors z-10"
            >
              <X className="w-4 h-4" />
            </button>
            <img
              src={selectedZoomImage}
              alt="Ampliação da corrediça"
              className="max-w-full max-h-[80vh] object-contain rounded-xl mx-auto"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BudgetSheetForm;
